import React, { useState, useContext, useEffect, useRef } from "react";
import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  TextareaAutosize,
  Paper,
  Autocomplete,
} from "@mui/material";
import { makeStyles } from "@material-ui/core";
import Picker from "react-mobile-picker-scroll";
import ModalCloseIcon from "../../assets/images/icon/modalCloseIconBlack";
import palette from "../../theme/palette";
import { UserTypeContext } from "../../context/userStatus";
import { trackingService } from "../../services/tracking";
import { ButtonLoader } from "../../components/buttonLoader";
import InfluenceclosePopup from "./InfluenceclosePopup";
import DeleteIcon from "../../assets/images/icon/DeleteIcon";
import {
  addCategoryJourneyAction,
  addJourneyAction,
  setUserHeart,
  setUserStreak,
} from "../../store/actions/userTypeAction";
import { AddUpdateEventModal } from "./addTrackingEventInfluenceModal";
import typography, { pxToRem } from "../../theme/typography";
import moment from "moment";
import { TrackingContext } from "../../context/userTracking";
import { setDayCompleteMessage } from "../../store/actions/trackerAction";
import CommonTypo from "../../components/CommonTypo";
const ArrowIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1090_701)">
    <path d="M13.825 6.6665L10 10.4832L6.175 6.6665L5 7.8415L10 12.8415L15 7.8415L13.825 6.6665Z" fill="#656565" />
  </g>
  <defs>
    <clipPath id="clip0_1090_701">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
const optionGroups = {
  hour: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ],
  minutus: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ],
  // AMPM: ["AM", "PM"],
};

const useStyles = makeStyles((theme) => ({
  registrationHeading: {
    color: `${palette.primary.light}!important`,
    marginBottom: "20px!important",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px!important",
    },
  },
  pageTitle: {
    marginBottom: "16px!important",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px!important",
    },
  },
  dialogTitle: {
    color: `${palette.primary.light}!important`,
    fontSize: "26px!important",
    lineHeight: "26px!important",
    letterSpacing: "0.02em",
    marginBottom: "40px!important",
    padding: "0!important",
  },
  bottomButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    "& button:nth-child(2)": {
      // marginLeft: "24px",
      marginBottom: "0px !important",
    },
  },
  influenceCaption: {
    marginBottom: "20px!important",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px!important",
    },
  },
  marginRight: {
    marginRight: "10px!important",
  },
  marginLeft: {
    marginLeft: "10px!important",
  },
  padding: {
    paddingTop: "20px!important",
  },
  textarea: {
    width: "100%",
    padding: "16px",
    fontFamily: typography.fontFamily,
    fontSize: "16px",
    fontWeight: 400,
    resize: "vertical",
    border: `1px solid var(--color-border) !important`,
    marginBottom: `0px !important`,
    marginTop: "6px",
    "&:focus-visible": {
      outline: "red"
    },
    "&::placeholder": {
      fontSize: `16px !important`,
      color: "var(--color-text-secondary) !important",
      opacity: 1
    }
  },
  textareaMobile: {
    width: "100%",
    padding: "16px",
    fontFamily: typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    resize: "vertical",
    border: `1px solid var(--color-border) !important`,
    marginBottom: `0px !important`,
    marginTop: "6px",
    "&:focus-visible": {
      outline: "red"
    },
    "&::placeholder": {
      fontSize: `14px !important`,
      color: "var(--color-text-secondary) !important"
    }
  },
}));

interface AddTimeOfDay {
  setOpenTimeOfDayModal: (openTimeOfDayModal: boolean) => void;
  item: any;
  isEdit: Boolean;
  setIsEdit: (isEdit: boolean) => void;
  journeyData: any;
  headerDate: any;
  setShowSnakbar: (showSnakbar: boolean) => void;
  setSnakbarMsg: (snakbarMsg: string) => void;
  setMsgType: (msgType: string) => void;
  callService: any;
  setInfluenceId: (influenceId: string) => void;
  callToGetData?: boolean;
  isMobile?: boolean;
  renderToNextInput?: () => void;
  categoryId?: string;
}

const AddTimeOfDay = (props: AddTimeOfDay) => {
  const classes = useStyles();
  const { state: outcomeState, dispatch: UserTypeDispatch } =
    useContext(UserTypeContext);
  const { dispatch: trackingDispatch } = useContext(TrackingContext);
  const [openStartModal, setStartModal] = useState(true);
  const [notes, setNotes] = useState<any>("");
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [showLoadingBtn, setShowLoadingBtn] = useState(false);
  const [hour, setHour] = useState(moment(new Date()).format("HH"));
  const [minute, setMinute] = useState(moment(new Date()).format("mm"));
  const [previoushour, setPreviousHour] = useState(moment(new Date()).format("HH"));
  const [previousminute, setPreviousMinute] = useState(moment(new Date()).format("mm"));
  const [editData, setEditData] = useState<any>();
  const [textAreaFocused, setTextAreaFocused] = useState<boolean>(false);
  const [openInfluenceclosePopup, setopenInfluenceclosePopup] = useState(false);
  const [openInfluenceDeletePopup, setopenInfluenceDeletePopup] =
    useState(false);
  const [endTimeValuegroup, setEndTimeValuegroup] = useState({
    hour: moment(new Date()).format("HH"),
    minutus: moment(new Date()).format("mm"),
    AMPM: moment.utc(new Date()).format("A"),
  });
  const [isBackButtonClicked, setBackbuttonPress] = useState(false);
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hour, notes, minute, isBackButtonClicked]);
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (!isBackButtonClicked) {
      setBackbuttonPress(true);
      if (
        editData?.influenceId &&
        editData?.hour === hour &&
        editData?.minute === minute &&
        (notes === editData?.note[0] || (!notes && !editData?.note[0]))
      ) {
        handleCloseStartModal();
      } else if (hour !== "" || notes !== "" || minute !== "") {
        setopenInfluenceclosePopup(true);
      } else {
        handleCloseStartModal();
      }
    }
  };
  let inputRef = null;
  const { isMobile = false } = props;
  useEffect(() => {
    const outcomeGetData = {
      influenceId: props.item?.influenceId,
      date: props?.headerDate,
    };
    trackingService
      .getInfluenceRes(outcomeState.token, outcomeGetData)
      .then((data) => {
        setEditData(data?.data);
        if (data?.data === null) {
          props?.setIsEdit(false);
          previousData();
        } else {
          props?.setIsEdit(true);
          setNotes(data?.data?.note[0] ?? "");
          const time = data?.data?.timeOfDay.split(":");
          setHour(time[0] ?? "");
          setMinute(time[1] ?? "");
          setPreviousHour(time[0] ?? "")
          setPreviousMinute(time[1] ?? "");
          setEndTimeValuegroup({
            hour: time[0] ?? moment(new Date()).format("HH"),
            minutus: time[1] ?? moment(new Date()).format("mm"),
            AMPM: moment.utc(new Date()).format("A"),
          });
          setEditData({
            hour: time[0],
            minute: time[1],
            ...data?.data,
          });
        }
      })
      .catch((error) => {
        console.log("outcome response get error");
      });
  }, []);
  useEffect(
    () => {
      // if (inputRef.current) {
      //   const refff: any = inputRef.current
      //   refff.focus()
      // }
      // if(inputRef) {
      //   inputRef.focus()
      // }
    } /* , [inputRef.current] */
  );
  const handleCloseStartModal = async () => {
    if(outcomeState.tutorialVisible) {
      return false
    }
    setStartModal(false);
    await props.setOpenTimeOfDayModal(false);
    props.setInfluenceId("");
    if (!editData?.influenceId) {
      props?.renderToNextInput();
    }
  };
  const handleDeleteEntry = () => {
    let payload = {
      influenceId: editData?.influenceId,
      date: props?.headerDate,
    };
    if (!outcomeState?.isPersonal) {
      const foundOutcome = (outcomeState?.influenceList || []).find(
        (it) => it.influenceId === payload.influenceId
      );
      if (foundOutcome) {
        const journyList = { ...(outcomeState?.journeyList || {}) } as any;
        const foundDateItemIcon = journyList.influence_data.findIndex(
          (it) =>
            it.influenceId === payload.influenceId &&
            it?.date === payload.date
        );
        if (foundDateItemIcon > -1) {
          journyList.influence_data.splice(foundDateItemIcon, 1);
        }
        UserTypeDispatch(addJourneyAction(journyList as any));
        
      }
    } else {
      const journeyCategoryList = [
        ...(outcomeState?.journeyCategoryList || []),
      ];
      const foundOutcome = (journeyCategoryList || []).findIndex(
        (it) =>
          it.influenceIds && it.influenceIds.includes(payload.influenceId)
      );
      if (foundOutcome > -1) {
        if (
          journeyCategoryList[foundOutcome].alls &&
          journeyCategoryList[foundOutcome].alls.length
        ) {
          const foundIndex = journeyCategoryList[
            foundOutcome
          ].alls.findIndex((it) => it.influenceId === payload.influenceId);
          if (foundIndex > -1) {
            if (
              journeyCategoryList[foundOutcome].alls[foundIndex]
                .influenceResponses &&
              journeyCategoryList[foundOutcome].alls[foundIndex]
                .influenceResponses.length
            ) {
              const foundDateValue = journeyCategoryList[foundOutcome].alls[
                foundIndex
              ].influenceResponses.findIndex(
                (it) => it.date === payload.date
              );
              if (foundDateValue > -1) {
                journeyCategoryList[foundOutcome].alls[
                  foundIndex
                ].influenceResponses.splice(foundDateValue, 1);
              }
            }
            UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
            
          }
        }
      } else {
        const foundOther = (journeyCategoryList || []).findIndex(
          (it) => it.name === "Other"
        );
        if (foundOther > -1) {
          const outcomeFound = journeyCategoryList[
            foundOther
          ].influences.findIndex(
            (it) => it.influenceId === payload.influenceId
          );
          if (outcomeFound > -1) {
            if (
              journeyCategoryList[foundOther].influences[outcomeFound]
                .influenceResponses &&
              journeyCategoryList[foundOther].influences[outcomeFound]
                .influenceResponses.length
            ) {
              const foundDateValue = journeyCategoryList[
                foundOther
              ].influences[outcomeFound].influenceResponses.findIndex(
                (it) => it.date === payload.date
              );
              if (foundDateValue > -1) {
                journeyCategoryList[foundOther].influences[
                  outcomeFound
                ].influenceResponses.splice(foundDateValue, 1);
              }
            }
            UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
            
          }
        }
      }
      const foundOutcomePersonal = (outcomeState?.influenceList || []).find(
        (it) => it.influenceId === payload.influenceId
      );
      if (foundOutcomePersonal) {
        const journyList = { ...(outcomeState?.journeyList || {}) } as any;
        const foundDateItemIcon = journyList.influence_data.findIndex(
          (it) =>
            it.influenceId === payload.influenceId &&
            it?.date === payload.date
        );
        if (foundDateItemIcon > -1) {
          journyList.influence_data.splice(foundDateItemIcon, 1);
        }
        UserTypeDispatch(addJourneyAction(journyList as any));
        
      }
    }
    trackingService
      .deleteInfluenceRes(outcomeState.token, payload)
      .then((data) => {
        if (props.callToGetData) {
          props?.callService(false);
        }
        setShowLoadingBtn(false);
        props.setShowSnakbar(false);
        props.setSnakbarMsg(data?.message);
        props.setOpenTimeOfDayModal(false);
        // props?.callService(false);
        props?.setInfluenceId("");
        props.setMsgType("success");
        if (!outcomeState?.isPersonal) {
          if (!editData?.influenceId) {
            props?.renderToNextInput();
          }
        }
      })
      .catch((error) => {
        setShowLoadingBtn(false);
        props.setShowSnakbar(true);
        props.setSnakbarMsg(
          error?.response?.data?.description
            ? error?.response?.data?.description
            : error?.message
        );
        props.setMsgType("error");
      });
  };

  const createTimeOfDayLevel = (e = null) => {
    e && e.preventDefault();
    setShowLoadingBtn(true);
    let outcomeCreateData;

    if (hour === "") {
      setShowLoadingBtn(false);
      props.setShowSnakbar(true);
      props.setSnakbarMsg("Please enter hours");
      props.setMsgType("error");
      return;
    } else if (minute === "") {
      setShowLoadingBtn(false);
      props.setShowSnakbar(true);
      props.setSnakbarMsg("Please enter minutes");
      props.setMsgType("error");
      return;
    } else if (parseInt(hour) > 23) {
      props.setShowSnakbar(true);
      props.setSnakbarMsg("Please enter hour from 0 and 23");
      props.setMsgType("error");
      setShowLoadingBtn(false);
      return;
    } else if (parseInt(minute) > 59) {
      props.setShowSnakbar(true);
      props.setSnakbarMsg("Please enter minute from 0 and 59");
      props.setMsgType("error");
      setShowLoadingBtn(false);
      return;
    }

    outcomeCreateData = {
      influenceId: props.item?.influenceId,
      note: notes === undefined || notes === "" ? [] : [notes],
      date: props?.headerDate,
      type: props?.item?.type,
      timeOfDay: `${hour}:${minute}`,
      response_type: "TIME_OF_THE_DAY",
    };
    trackingService
      .influenceCreate(outcomeState.token, outcomeCreateData)
      .then((data) => {
        if (!outcomeState?.isPersonal) {
          const foundOutcome = (outcomeState?.influenceList || []).find(
            (it) => it.influenceId === outcomeCreateData.influenceId
          );
          if (foundOutcome) {
            const journyList = { ...(outcomeState?.journeyList || {}) } as any;
            const foundDateItemIcon = journyList.influence_data.findIndex(
              (it) =>
                it.influenceId === outcomeCreateData.influenceId &&
                it?.date === outcomeCreateData.date
            );
            if (foundDateItemIcon > -1) {
              journyList.influence_data[foundDateItemIcon] = {
                ...foundOutcome,
                ...outcomeCreateData,
              };
            } else {
              journyList.influence_data.push({
                ...foundOutcome,
                ...outcomeCreateData,
              } as any);
            }
            UserTypeDispatch(addJourneyAction(journyList as any));
            // if (props.callToGetData) {
            //   props?.callService(false);
            // }
            if (!isMobile) {
              props?.renderToNextInput();
            }
          }
        } else {
          const journeyCategoryList = [
            ...(outcomeState?.journeyCategoryList || []),
          ];
          const foundOutcome = (journeyCategoryList || []).findIndex(
            (it) =>
              it.influenceIds &&
              it.influenceIds.includes(outcomeCreateData.influenceId)
          );
          if (foundOutcome > -1) {
            if (
              journeyCategoryList[foundOutcome].alls &&
              journeyCategoryList[foundOutcome].alls.length
            ) {
              const foundIndex = journeyCategoryList[
                foundOutcome
              ].alls.findIndex(
                (it) => it.influenceId === outcomeCreateData.influenceId
              );
              if (foundIndex > -1) {
                if (
                  journeyCategoryList[foundOutcome].alls[foundIndex]
                    .influenceResponses &&
                  journeyCategoryList[foundOutcome].alls[foundIndex]
                    .influenceResponses.length
                ) {
                  const foundDateValue = journeyCategoryList[foundOutcome].alls[
                    foundIndex
                  ].influenceResponses.findIndex(
                    (it) => it.date === outcomeCreateData.date
                  );
                  if (foundDateValue > -1) {
                    journeyCategoryList[foundOutcome].alls[
                      foundIndex
                    ].influenceResponses[foundDateValue] = {
                      ...outcomeCreateData,
                    };
                  } else {
                    journeyCategoryList[foundOutcome].alls[
                      foundIndex
                    ].influenceResponses.push(outcomeCreateData);
                  }
                } else {
                  journeyCategoryList[foundOutcome].alls[
                    foundIndex
                  ].influenceResponses = [outcomeCreateData];
                }
                UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
                // if (props.callToGetData) {
                //   props?.callService(false);
                // }
              }
            }
          } else {
            const foundOther = (journeyCategoryList || []).findIndex(
              (it) => it.name === "Other"
            );
            if (foundOther > -1) {
              const outcomeFound = journeyCategoryList[
                foundOther
              ].influences.findIndex(
                (it) => it.influenceId === outcomeCreateData.influenceId
              );
              if (outcomeFound > -1) {
                if (
                  journeyCategoryList[foundOther].influences[outcomeFound]
                    .influenceResponses &&
                  journeyCategoryList[foundOther].influences[outcomeFound]
                    .influenceResponses.length
                ) {
                  const foundDateValue = journeyCategoryList[
                    foundOther
                  ].influences[outcomeFound].influenceResponses.findIndex(
                    (it) => it.date === outcomeCreateData.date
                  );
                  if (foundDateValue > -1) {
                    journeyCategoryList[foundOther].influences[
                      outcomeFound
                    ].influenceResponses[foundDateValue] = {
                      ...outcomeCreateData,
                    };
                  } else {
                    journeyCategoryList[foundOther].influences[
                      outcomeFound
                    ].influenceResponses.push(outcomeCreateData);
                  }
                } else {
                  journeyCategoryList[foundOther].influences[
                    outcomeFound
                  ].influenceResponses = [outcomeCreateData];
                }
                UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
                // if (props.callToGetData) {
                //   props?.callService(false);
                // }
              }
            }
          }
          if (isMobile) {
            const foundOutcome = (outcomeState?.influenceList || []).find(
              (it) => it.influenceId === outcomeCreateData.influenceId
            );
            if (foundOutcome) {
              const journyList = {
                ...(outcomeState?.journeyList || {}),
              } as any;
              const foundDateItemIcon = journyList.influence_data.findIndex(
                (it) =>
                  it.influenceId === outcomeCreateData.influenceId &&
                  it?.date === outcomeCreateData.date
              );
              if (foundDateItemIcon > -1) {
                journyList.influence_data[foundDateItemIcon] = {
                  ...foundOutcome,
                  ...outcomeCreateData,
                };
              } else {
                journyList.influence_data.push({
                  ...foundOutcome,
                  ...outcomeCreateData,
                } as any);
              }
              UserTypeDispatch(addJourneyAction(journyList as any));
              // if (props.callToGetData) {
              //   props?.callService(false);
              // }
              if (!editData?.influenceId && !isMobile) {
                props?.renderToNextInput();
              }
            }
          }
          if (!editData?.influenceId && !isMobile) {
            setTimeout(() => {
              props?.renderToNextInput();
            }, 500);
          }
        }
        if (
          data.showMessage &&
          props?.headerDate === moment().format("MM-DD-YYYY")
        ) {
          trackingDispatch(
            setDayCompleteMessage({
              open: data.showMessage,
              message: data.message,
            })
          );
        }
        if(data.dataStreak) {
          UserTypeDispatch(setUserStreak())
        }
        if(data.heartIncreaseFlag) {
          UserTypeDispatch(setUserHeart())
        }
        setShowLoadingBtn(false);
        // props.setShowSnakbar(true);
        props.setSnakbarMsg(data?.message);
        props.setOpenTimeOfDayModal(false);
        // props?.callService(false);
        // props?.setInfluenceId("");
        props.setMsgType("success");
      })
      .catch((error) => {
        setShowLoadingBtn(false);
        props.setShowSnakbar(true);
        props.setSnakbarMsg(
          error?.response?.data?.description
            ? error?.response?.data?.description
            : error?.message
        );
        props.setMsgType("error");
      });
  };
  const onKeyDownHandler = (e) => {
    let keyPress = e.ctrlKey || e.altKey;
    console.log("keyPress", keyPress, e.keyCode);
    
    if ((keyPress && (([65, 85, 13].includes(e.keyCode))))) {
      // if (!textAreaFocused) {
        createTimeOfDayLevel();
      // }
    } else if (keyPress && [75].includes(e.keyCode)) {
      props.setOpenTimeOfDayModal(false);
      props.renderToNextInput && !isMobile && props.renderToNextInput()
      setShowLoadingBtn(false);
      setStartModal(false)
      props.setShowSnakbar(false);
      props.setInfluenceId("");
    }
  };
  const focusUsernameInputField = (input) => {
    if (input) {
      setTimeout(() => {
        input.focus();
      }, 100);
    }
  };
  const previousData = () => {
    const outcomeGetData = {
      influenceId: props.item?.influenceId,
      date: props?.headerDate,
    };
    trackingService
      .getLastInfluenceRes(outcomeState.token, outcomeGetData)
      .then((data) => {
        console.log("data", data);
        if (data.data) {
          const time = data.data.timeOfDay.split(":");
          setHour(time[0] ?? "");
          setMinute(time[1] ?? "");
          setPreviousHour(time[0] ?? "")
          setPreviousMinute(time[1] ?? "");
          setEndTimeValuegroup({
            hour: time[0] ?? moment(new Date()).format("HH"),
            minutus: time[1] ?? moment(new Date()).format("mm"),
            AMPM: moment.utc(new Date()).format("A"),
          });
        }
      })
      .catch((error) => {
        console.log("outcome response get error");
      });
    return null;
  };
  const defaultProps = {
    options: optionGroups.hour && optionGroups.hour.length ? optionGroups.hour.filter(it => it).sort(function (a, b) {
      if (a.toLowerCase() < b.toLowerCase()) {
        return -1;
      }
      if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
      }
      return 0;
    }) : [],
    getOptionLabel: (option) => option,
  };
  const defaultProps2 = {
    options: optionGroups.minutus && optionGroups.minutus.length ? optionGroups.minutus.filter(it => it).sort(function (a, b) {
      if (a.toLowerCase() < b.toLowerCase()) {
        return -1;
      }
      if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
      }
      return 0;
    }) : [],
    getOptionLabel: (option) => option,
  };
  return (
    <Grid>
      <AddUpdateEventModal
        onClose={
          editData?.influenceId &&
            editData?.hour === hour &&
            editData?.minute === minute &&
            (notes === editData?.note[0] || (!notes && !editData?.note[0]))
            ? handleCloseStartModal
            : (hour !== "" || notes !== "" || minute !== "") && (hour !== previoushour || minute !== previousminute)
              ? outcomeState.tutorialVisible ? () => {} : () => {
                setopenInfluenceclosePopup(true);
              }
              : handleCloseStartModal
        }
        isDarkMode={outcomeState.isDarkMode}
        onSave={createTimeOfDayLevel}
        showTitle
        isMobile={props.isMobile}
        paperProps={
          isMobile
            ? {
              height: "calc(100vh - 27%)",
            }
            : {
              width: "360px"
            }
        }
        title={
          <>
            {false ? (
              <>
                {props?.isEdit ? "Update Tracking Event" : "Add Tracking Event"}
                {editData?.influenceId && (
                  <IconButton
                    onClick={() => {
                      setopenInfluenceDeletePopup(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </>
            ) : <CommonTypo size={24} lineHeight={28.8} fontWeight={700} color="var(--color-text-primary)"> {props?.isEdit ? "Update Tracking Event" : "Add Tracking Event"}</CommonTypo>}
          </>
        }
        deleteIcon={editData?.influenceId && <IconButton
          onClick={() => {
            setopenInfluenceDeletePopup(true);
          }}
        >
          <DeleteIcon color="var(--color-text-primary)" size="24" />
        </IconButton>}
        showLoadingBtn={showLoadingBtn}
        visible={openStartModal}
        showCloseIcon
        buttonText={
          props?.isEdit ? (
            <span>
              <span style={{ textDecoration: "underline" }}>U</span>pdate
            </span>
          ) : (
            <span>
              <span style={{ textDecoration: "underline" }}>A</span>dd
            </span>
          )
        }
        saveDisabled={
          !(hour !== "" && Boolean(hour) && minute !== "" && Boolean(minute))
        }
      >
        {/* {isMobile && editData?.influenceId && (
          <div
            style={{
              position: "absolute",
              right: 0,
              top: 0,
            }}
          >
            <IconButton
              onClick={() => {
                setopenInfluenceDeletePopup(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        )} */}
        <form onKeyDown={onKeyDownHandler}>
          {true ? <CommonTypo size={18} lineHeight={21.6} fontWeight={600} color="var(--color-text-primary)"> {props?.item?.name || "Name"}</CommonTypo> : <div
            style={{
              display: "flex",
              padding: props.isMobile ? "0px" : "24px 32px 0px 32px",
              flexDirection: "column",
              alignItems: props.isMobile ? "flex-start" : "center",
              gap: props.isMobile ? "24px" : "16px",
              justifyContent: "center",
              width: "100%",
              alignSelf: "stretch",
            }}
          >
            <Typography
              variant="body1"
              component="div"
              sx={
                isMobile
                  ? {
                    color: palette.primary.light,
                    fontSize: `${pxToRem(20)} !important`,
                    lineHeight: "125% !important",
                    // textAlign: "center !important",
                    fontWeight: `500 !important`,
                    "&.MuiTypography-root": {
                      "@media  (max-width: 600px) and (min-width: 100px)": {
                        fontSize: `${pxToRem(20)} !important`,
                        lineHeight: "125% !important",
                      },
                    },
                  }
                  : {
                    fontWeight: 600,
                    fontSize: `${pxToRem(24)} !important`,
                    lineHeight: "135%  !important",
                  }
              }
              className={classes.registrationHeading}
            >
              {props?.item?.name || "Name"}
            </Typography>
          </div>}
          <div
            style={{
              display: "flex",
              padding: true ? "0px" : "32px",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "24px",
              alignSelf: "stretch",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "24px",
                alignSelf: "stretch",
              }}
            >
              {/* <Typography
                variant="caption"
                component="p"
                className={classes.pageTitle}
              >
                When did this happen last?
              </Typography> */}
              {props.isMobile ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "16px",
                    alignSelf: "stretch",
                    marginTop: "24px",
                  }}
                >
                  {!isMobile && <Typography
                    variant="caption"
                    component="p"
                    className={classes.pageTitle}
                    sx={{
                      color: palette.primary.light,
                      fontSize: `${pxToRem(16)} !important`,
                      lineHeight: "125% !important",
                      // textAlign: "center !important",
                      fontWeight: `500 !important`,
                      "&.MuiTypography-root": {
                        "@media  (max-width: 600px) and (min-width: 100px)": {
                          fontSize: `${pxToRem(16)} !important`,
                          lineHeight: "125% !important",
                        },
                      },
                    }}
                  >
                    When did this happen today?
                  </Typography>}
                  <Picker
                    optionGroups={optionGroups}
                    valueGroups={endTimeValuegroup}
                    onChange={(name, value) => {
                      if(!props.item.lockMatrix) {
                        setEndTimeValuegroup({
                          ...endTimeValuegroup,
                          [name]: value,
                        });
                        if (name === "hour") {
                          setHour(value);
                        }
                        if (name === "minutus") {
                          setMinute(value);
                        }
                      }
                    }}
                  />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    alignSelf: "stretch",
                    width: "100%",
                    marginTop: "24px"
                  }}
                >
                  <Autocomplete
                    className=" weekSelect"
                    fullWidth
                    disableClearable
                    value={hour || ""}
                    sx={{
                      position: "relative",
                      "& .MuiOutlinedInput-root": {
                        padding: 0,
                      },
                    }}
                    disabled={props.item.lockMatrix}
                    renderGroup={(params) => {
                      return (
                        <li key={params.key}>
                          <Box sx={{ padding: '10px 10px' }}>
                            <Typography variant="subtitle1" sx={{
                              color: palette.primary.light,
                              fontSize: `${pxToRem(16)} !important`,
                              lineHeight: "120% !important",
                              cursor: "pointer",
                              // textAlign: "center !important",
                              fontWeight: `400 !important`,
                              "&.MuiTypography-root": {
                                "@media  (max-width: 600px) and (min-width: 100px)": {
                                  fontSize: `${pxToRem(16)} !important`,
                                  lineHeight: "100% !important",
                                },
                              },
                            }}>{params.group}</Typography>
                          </Box>
                          <Box sx={{ padding: '0 0px' }}>
                            {params.children}
                          </Box>
                        </li>
                      )
                    }}
                    autoComplete
                    // onOpen={() => setOpen(true)}
                    // onClose={() => setOpen(false)}
                    popupIcon={null}
                    PaperComponent={({ children }) => (
                      <Paper
                        style={{ background: "var(--white-background)" }}
                        sx={{
                          "&.MuiAutocomplete-option": {
                            color: "rgb(0, 0, 0)",
                            fontSize: "18px",
                          },
                          "& .MuiAutocomplete-listbox": {
                            padding: "0px",
                            "& li": {
                              padding: `10px`,
                              color: "#5E5F5E !important",
                              fontSize: "16px !important",
                              fontWeight: "400 !important",
                              lineHeight: "24px",
                            },
                          },
                        }}
                      >
                        {children}
                      </Paper>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          display: "flex",
                          padding: "18px",
                          alignItems: "center",
                          gap: "12px",
                          flex: "1 0 0",
                          borderRadius: "12px",
                          border: "1px solid #EDEDED",
                          background: "var(--white-background)",
                          marginBottom: `0 !important`,
                          "& .MuiInputBase-root": {
                            width: "100%",
                            "& .MuiInputBase-input": {
                              padding: `0px !important`,
                            },
                          },
                        }}
                        onChange={(e) => {
                          const found = optionGroups.hour.find(it => it === e.target.value)
                          if(found) {
                            setHour(found);
                          }
                        }}
                      // className=" weekSelect"
                      // label="Select one"
                      />
                    )}
                    onChange={(e, newInputValue) => {
                      console.log("newInputValue", newInputValue);
                      setHour(newInputValue);
                      // setSelectedLeft(newInputValue);
                    }}
                    {...defaultProps}
                  />
                  <Typography
                    variant="caption"
                    component="div"
                    className={`${classes.influenceCaption} ${classes.padding}`}
                  >
                    :
                  </Typography>
                  <Autocomplete
                    className=" weekSelect"
                    fullWidth
                    value={minute || ""}
                    sx={{
                      position: "relative",
                      "& .MuiOutlinedInput-root": {
                        padding: 0,
                      },
                    }}
                    disabled={props.item.lockMatrix}
                    renderGroup={(params) => {
                      return (
                        <li key={params.key}>
                          <Box sx={{ padding: '10px 10px' }}>
                            <Typography variant="subtitle1" sx={{
                              color: palette.primary.light,
                              fontSize: `${pxToRem(16)} !important`,
                              lineHeight: "120% !important",
                              cursor: "pointer",
                              // textAlign: "center !important",
                              fontWeight: `400 !important`,
                              "&.MuiTypography-root": {
                                "@media  (max-width: 600px) and (min-width: 100px)": {
                                  fontSize: `${pxToRem(16)} !important`,
                                  lineHeight: "100% !important",
                                },
                              },
                            }}>{params.group}</Typography>
                          </Box>
                          <Box sx={{ padding: '0 0px' }}>
                            {params.children}
                          </Box>
                        </li>
                      )
                    }}
                    autoComplete
                    disableClearable
                    // onOpen={() => setOpen(true)}
                    // onClose={() => setOpen(false)}
                    popupIcon={null}
                    PaperComponent={({ children }) => (
                      <Paper
                        style={{ background: "var(--white-background)" }}
                        sx={{
                          "&.MuiAutocomplete-option": {
                            color: "rgb(0, 0, 0)",
                            fontSize: "18px",
                          },
                          "& .MuiAutocomplete-listbox": {
                            padding: "0px",
                            "& li": {
                              padding: `10px`,
                              color: "#5E5F5E !important",
                              fontSize: "16px !important",
                              fontWeight: "400 !important",
                              lineHeight: "24px",
                            },
                          },
                        }}
                      >
                        {children}
                      </Paper>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          display: "flex",
                          padding: "18px",
                          alignItems: "center",
                          gap: "12px",
                          flex: "1 0 0",
                          borderRadius: "12px",
                          border: "1px solid #EDEDED",
                          background: "var(--white-background)",
                          marginBottom: `0 !important`,
                          "& .MuiInputBase-root": {
                            width: "100%",
                            "& .MuiInputBase-input": {
                              padding: `0px !important`,
                            },
                          },
                        }}
                        onChange={(e) => {
                          const found = optionGroups.minutus.find(it => it === e.target.value)
                          if(found) {
                            setMinute(found);
                          }
                        }}
                      // className=" weekSelect"
                      // label="Select one"
                      />
                    )}
                    onChange={(e, newInputValue) => {
                      console.log("newInputValue", e, newInputValue);
                      // setHour(newInputValue);
                      setMinute(newInputValue);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Optional: prevent default form submission
                        createTimeOfDayLevel(e)
                        // if (e.target.value) {
                        //   const value = e.target.value.trim();
                        //   const found = optionGroups.minutus.find(it => it === value);
                        //   if (found) {
                        //     setMinute(found);
                        //   }
                        // }
                      }
                    }}
                    {...defaultProps2}
                  />
                </div>
              )}

              <div
                style={
                  true
                    ? {
                      width: "100%",
                      marginTop: "0px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "24px",
                    }
                    : { width: "100%", marginTop: "32px" }
                }
              >
                {false && <Typography
                  variant="caption"
                  component="p"
                  className={classes.pageTitle}
                  sx={
                    isMobile
                      ? {
                        color: palette.primary.light,
                        fontSize: `${pxToRem(16)} !important`,
                        lineHeight: "125% !important",
                        // textAlign: "center !important",
                        fontWeight: `500 !important`,
                        "&.MuiTypography-root": {
                          "@media  (max-width: 600px) and (min-width: 100px)":
                          {
                            fontSize: `${pxToRem(16)} !important`,
                            lineHeight: "125% !important",
                          },
                        },
                      }
                      : {}
                  }
                >
                  {isMobile
                    ? "Note for today’s entry"
                    : "Add a note for today’s entry"}
                </Typography>}
                {props.isMobile ? (
                  <TextareaAutosize
                    // variant="outlined"
                    className={
                      "textarea " +
                      (true ? classes.textareaMobile : classes.textarea)
                    }
                    // fullWidth
                    placeholder={/* isMobile ? "What’s worth remembering today?": */isMobile ? "Add comment..." : "Add a note..."}
                    // multiline
                    minRows={3}
                    maxRows={true ? 3 : undefined}
                    onChange={(e) => setNotes(e.target.value)}
                    value={notes || ""}
                  />
                ) : (
                  <TextareaAutosize
                    // variant="outlined"
                    className={
                      "textarea " +
                      (classes.textarea)
                    }
                    // fullWidth
                    placeholder={"Add comment..."}
                    // multiline
                    minRows={3}
                    maxRows={3}
                    style={{
                      marginBottom: '0px!important'
                    }}
                    autoFocus
                    onChange={(e) => setNotes(e.target.value)}
                    value={notes || ""}
                  />
                )}
              </div>
            </div>
          </div>
        </form>
        <InfluenceclosePopup
          open={openInfluenceDeletePopup}
          isDelete={openInfluenceDeletePopup}
          setopenInfluenceclosePopup={setopenInfluenceDeletePopup}
          handleCloseStartModal={handleDeleteEntry}
          setBackbuttonPress={setBackbuttonPress}
        />
        <InfluenceclosePopup
          open={openInfluenceclosePopup}
          setopenInfluenceclosePopup={setopenInfluenceclosePopup}
          handleCloseStartModal={handleCloseStartModal}
          setBackbuttonPress={setBackbuttonPress}
        />
      </AddUpdateEventModal>
    </Grid>
  );
};

export default AddTimeOfDay;
